<template>
  <div>
    <c-q-btn
      v-if="showCancelButton"
      id="btn-cancel-focused-institutional"
      propBtnLabel="Cancelar"
      :propBtnFunction="openDialog"
      :propBtnTransparent="true"
      :propBtnSize="EnumButtonSizes.LARGE_1"
    />

   <ModalConfirmationDialog
  propDialogTitle="Atenção!"
  propConfirmationMsg="Tem certeza de que deseja cancelar o cadastro?"
  propDialogType="cancelar-institucional"
  @confirm="onCancelFocusedInstitutionalBtnClick"
/>

  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { EnumButtonSizes } from '@/enums/enums'

import ModalConfirmationDialog from '@/views/modals/ModalConfirmationDialog.vue'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'

import messages from '@/utils/messages'
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()

/**
 * ✅ REGRA DE EXIBIÇÃO DO BOTÃO CANCELAR
 */
const showCancelButton = computed(() => {
  const status = institutionalStore.institutionalDetail?.status

  return (
    authStore.currentUserCanCancelInstitutional &&
    !!status &&
    [
      CONST_INSTITUTIONAL_STATUS.ADJUSTMENT_REQUESTED,
      CONST_INSTITUTIONAL_STATUS.ON_EDITING.id,
      CONST_INSTITUTIONAL_STATUS.APPROVED.id,
      CONST_INSTITUTIONAL_STATUS.PENDING_PUBLICATION.id,
      CONST_INSTITUTIONAL_STATUS.ACTIVE_INSTITUTIONAL.id,
      CONST_INSTITUTIONAL_STATUS.PUBLISHED.id
    ].includes(status)
  )
})

/**
 * Abre modal de confirmação
 */
const openDialog = () => {
  pagesUtilStore.showModalConfirmationCancelInstitutional = true // ✅
}


/**
 * Confirma cancelamento
 */
const onCancelFocusedInstitutionalBtnClick = async () => {
  try {
    pagesUtilStore.showLoading = true

    const id = institutionalStore.institutionalDetail?.id

    if (!id) return

    await institutionalStore.cancelInstitutional(id)

    messages.showSuccessMsg('Cadastro cancelado com sucesso!')

  } catch (error) {
    console.error(error)
    messages.showErrorMsg('Erro ao cancelar o cadastro.')
  } finally {
    pagesUtilStore.showLoading = false
  }
}
</script>

<style scoped>
</style>
